import { useState, useEffect } from 'react';
import { supabase } from './supabaseClient';

export const useDeviceSettings = (userId) => {
  const [deviceSettings, setDeviceSettings] = useState({
    leftFootDevice: null,
    rightFootDevice: null
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!userId) {
      setLoading(false);
      return;
    }

    const fetchDeviceSettings = async () => {
      try {
        const { data, error } = await supabase
          .from('profiles')
          .select('device_settings')
          .eq('id', userId)
          .single();

        if (error) throw error;

        if (data?.device_settings) {
          setDeviceSettings({
            leftFootDevice: data.device_settings.leftFootDevice || null,
            rightFootDevice: data.device_settings.rightFootDevice || null
          });
        }
      } catch (error) {
        console.error('Error fetching device settings:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchDeviceSettings();

    const subscription = supabase
      .channel(`device-settings-${userId}`)
      .on(
        'postgres_changes',
        {
          event: 'UPDATE',
          schema: 'public',
          table: 'profiles',
          filter: `id=eq.${userId}`
        },
        (payload) => {
          if (payload.new.device_settings) {
            setDeviceSettings({
              leftFootDevice: payload.new.device_settings.leftFootDevice || null,
              rightFootDevice: payload.new.device_settings.rightFootDevice || null
            });
          }
        }
      )
      .subscribe();

    return () => {
      subscription.unsubscribe();
    };
  }, [userId]);

  return { deviceSettings, loading };
};
